// Messages for operator/OtpChallenge (auto-merged by lib/i18n.ts).
export const en = {
  'operator.otp.head': 'Two-factor — Operator',
  'operator.otp.title': 'Two-factor verification',
  'operator.otp.subtitle':
    'Enter the 6-digit code from your authenticator app, or a recovery code.',
  'operator.otp.code_label': 'Verification code',
  'operator.otp.code_error': 'Code {error}',
  'operator.otp.submit': 'Verify',
}

export const zhTW = {
  'operator.otp.head': '雙重驗證 — 操作端',
  'operator.otp.title': '雙重驗證',
  'operator.otp.subtitle': '輸入驗證器應用程式中的 6 位數驗證碼，或備用碼。',
  'operator.otp.code_label': '驗證碼',
  'operator.otp.code_error': '驗證碼{error}',
  'operator.otp.submit': '驗證',
}
